import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { SensemakerPageTitle } from '@/shared/components/SensemakerPageTitle'
import { useDocumentTitle } from '@/shared/hooks/useDocumentTitle'
import { APP_SHELL_PAGE_TITLE_ROW_MARGIN_BOTTOM_PX } from '@/shared/layout/appShellPageLayout'

interface Props {
  title: string
  description: string
  testId: string
}

/** Placeholder shell for Platform Admin screens not yet implemented. */
export function PlatformAdminStubPage({ title, description, testId }: Props) {
  useDocumentTitle(title)

  return (
    <Box data-testid={testId}>
      <Box sx={{ mb: `${APP_SHELL_PAGE_TITLE_ROW_MARGIN_BOTTOM_PX}px` }}>
        <SensemakerPageTitle title={title} description={description} />
      </Box>
      <Typography sx={{ color: 'text.secondary' }}>This screen is coming soon.</Typography>
    </Box>
  )
}
